import { useQuery } from '@tanstack/react-query';
import { Table, Tag } from 'antd';
import type { ColumnsType } from 'antd/es/table';

import Panel from '@/components/Panel';
import { api } from '@/lib/api';

interface CarModel {
  model_id: string;
  brand_id: string;
  model_name: string;
  model_alias: string[];
  platform_model_ids: Record<string, string>;
  segment: string | null;
  powertrain_type: string | null;
}

const columns: ColumnsType<CarModel> = [
  { title: '品牌', dataIndex: 'brand_id', key: 'brand_id', width: 130 },
  {
    title: '标准车型',
    dataIndex: 'model_name',
    key: 'model_name',
    width: 160,
    render: (n) => <span className="font-medium">{n}</span>,
  },
  {
    title: '车型 ID',
    dataIndex: 'model_id',
    key: 'model_id',
    width: 180,
    render: (id) => <code className="text-[11px]">{id}</code>,
  },
  { title: '级别', dataIndex: 'segment', key: 'segment', width: 140 },
  {
    title: '能源',
    dataIndex: 'powertrain_type',
    key: 'powertrain_type',
    width: 110,
    render: (p) => <Tag>{p}</Tag>,
  },
  {
    title: '别名',
    dataIndex: 'model_alias',
    key: 'model_alias',
    render: (aliases: string[]) => (
      <div className="flex gap-1 flex-wrap">
        {aliases.map((a) => (
          <Tag key={a} className="text-[11px]">
            {a}
          </Tag>
        ))}
      </div>
    ),
  },
];

export default function CatalogPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['catalog-models'],
    queryFn: async () => {
      const res = await api.get<CarModel[]>('/catalog/models');
      return res.data;
    },
  });

  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-[17px] lg:text-[20px] font-semibold text-slate-900 m-0">车型字典</h1>
        <p className="text-[12px] lg:text-[13px] text-slate-500 mt-1 mb-0">
          全部广汽品牌 · {data?.length ?? 0} 个标准车型 · 平台别名映射
        </p>
      </div>

      <Panel title={`车型清单（共 ${data?.length ?? 0} 个）`} noPadding>
        <Table
          rowKey="model_id"
          columns={columns}
          dataSource={data ?? []}
          loading={isLoading}
          pagination={{ pageSize: 50 }}
          size="middle"
          scroll={{ x: 'max-content' }}
        />
      </Panel>
    </div>
  );
}
